import React from 'react'
import { Col, Row } from 'reactstrap'

const BloodImportance = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding4rem right-padding4rem pb-md-5 pb-4'>
            <div className=''>
                <text className='fs-ss-32-1 text-montserrat text-ss-primary fw-700 lh-1-2'>
                    Importance of General Blood Work
                </text>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='py-3'>
                <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    General blood work, including a complete blood count (CBC), A1C, and a basic metabolic panel (BMP), are fundamental to healthcare assessments. It provides valuable insights into your overall health and helps healthcare providers in several ways. 
                </text>
            </div>

            <div className=''>
                <Row className=''>
                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className='ms-0'>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon1-ULC-General-Blood-Work.png' className='img-w15' alt='Assess Organ Function' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Assess Organ Function
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600 ' style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                    General blood work helps evaluate the functioning of vital organs such as the kidneys, liver, heart, and thyroid. Abnormalities in blood markers can indicate potential issues or imbalances requiring further investigation.
                                </text>
                            </div>
                        </div>
                    </Col>

                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon2-ULC-General-Blood-Work.png' className='img-w15' alt='Diagnose Diseases' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Diagnose Diseases
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600' style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                Blood work tests are crucial in diagnosing various diseases, including cancer, diabetes, coronary heart disease, and HIV/AIDS. They can detect specific markers or blood abnormalities associated with these conditions, aiding in early diagnosis and prompt treatment.
                                </text>
                            </div>
                        </div>
                    </Col>

                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon3-ULC-General-Blood-Work.png' className='img-w15' alt='Monitor Medication Effectiveness' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Monitor Medication Effectiveness
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600'  style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                The test results can determine if prescribed medications effectively address your health condition. They help healthcare providers gauge the impact of medicines on specific markers and adjust the treatment plan accordingly.
                                </text>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className=''>
                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className='ms-0'>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon4-ULC-General-Blood-Work.png' className='img-w15' alt='Diagnose Bleeding or Clotting' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Diagnose Bleeding or Clotting
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600 ' style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                Abnormal bleeding or clotting can be indicators of underlying disorders. Blood tests assess the clotting factors and platelet count, providing valuable information for diagnosing hemophilia or thrombophilia.
                                </text>
                            </div>
                        </div>
                    </Col>

                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon5-ULC-General-Blood-Work.png' className='img-w15' alt='Evaluate Immune System Health' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Evaluate Immune System Health
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600' style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                Various tests help identify abnormalities in immune system function, such as deficiencies or autoimmune disorders. They can also assess the body's response to infections and determine if the immune system is compromised.
                                </text>
                            </div>
                        </div>
                    </Col>

                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon7-ULC-General-Blood-Work.png' className='img-w15' alt='Identify Hemoglobin Variations' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Identify Hemoglobin Variations
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600'  style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                General blood work tests can identify variations in hemoglobin like S, C, or E. Moreover, these are common in people of African, Mediterranean, or Southeast Asian backgrounds. This information helps healthcare providers understand potential risks and provide appropriate care.
                                </text>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className=''>
                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className='ms-0'>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon6-ULC-General-Blood-Work.png' className='img-w15' alt='Diagnose Anemia' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Diagnose Anemia
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600 ' style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                Anemia is a deficiency in red blood cells or hemoglobin. General blood work CBC and CMP tests can detect several types of anemia, such as iron-deficiency anemia, pernicious anemia, aplastic anemia, or hemolytic anemia. Identifying the underlying cause is essential for appropriate treatment.
                                </text>
                            </div>
                        </div>
                    </Col>

                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon8-ULC-General-Blood-Work.png' className='img-w15' alt='Monitor Chronic Health Conditions' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Monitor Chronic Health Conditions
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600' style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                For individuals with chronic health conditions, regular blood tests are essential for monitoring disease progression, evaluating treatment effectiveness, and adjusting medication dosages. They provide valuable data to guide ongoing care.
                                </text>
                            </div>
                        </div>
                    </Col>

                    <Col md='4' className='pt-4'>
                        <div className=''>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/icon9-ULC-General-Blood-Work.png' className='img-w15' alt='Detect Health Problems Early' />
                            </div>

                            <div className='py-3'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-black'>
                                    Detect Health Problems Early
                                </text>
                            </div>

                            <div className='pe-md-4'>
                                <text className='fs-ss-14-3 text-montserrat text-ss-black fw-600'  style={{ display:'flex', textAlign:'justify', lineHeight:1.6}}>
                                Routine health check-ups often include general blood work. By analyzing various blood markers, healthcare providers can identify potential health problems at an early stage, even before symptoms manifest. Early detection allows for timely intervention and better treatment outcomes.
                                </text>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default BloodImportance